module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAABGdBTUEAALGPC/xhBQAAAPBJREFUKBWFkj9SwkAYRzNM4BZQEDtOEJLGnuNQ4wUsgSOgp6DzFNZa2dgA2sT3NrtMwgzxN/Py/d1NNt9mWUdN0yzhBT7gJ1rjutPWuiRz2MKQdhTz62ICE+oMT1DAJFrjE6hdWIRThbAtlNedOg71EtxQVRmPQ3B5g334MziCZ9LOYn6F/w7PNnloVcSijV0dzfdE1R3VxAI2xSFp3FtAMIKvmJxG+xZtMrdx2Nk5qP/O9EDPGhZ+jgNV/p17f++R2rdNqB00TpqT89jAHMbRGl9A7dM3+zZvxN7sgPo3Iq1mQQ3p7v3if8IrVKlH+wcFT5qvnFKhEwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-indicator-core-white.png
// module id = 53
// module chunks = 0